import { Calendar, Filter, Trash2, X } from "lucide-react";

import { useState } from "react";
import CalendarAll from "../CalandarAll";
import DropDownButtonUIClient from "../DropDownButtonUIClient";
import { dashboardCard1Object } from "../ExportDashboardCard1Object";

const FilterTopDash =({sort, setSort,dropDownVal, setDropDownVal, setExpStartDate, setExpEndDate,setPageNo, setEnrollStartDate,setEnrollEndDate,advancedFilters , setAdvancedFilters,toggleStatePaid , setToggleStatePaid,toggleStateLifetime , setToggleStateLifetime})=>{
 
      function convertToYMD(dateStr) {
                
  const [day, month, year] = dateStr?.split("-");
  return `${year}-${month}-${day}`;
}
function formatDate(dateStr) {
  if (!dateStr) return { isoDate: "Invalid", readable: "Invalid date" };

  // Normalize separators (in case it's "27/06/2025" etc.)
  const clean = dateStr.replace(/\//g, "-").trim();

  const parts = clean.split("-");
  if (parts.length !== 3) return { isoDate: "Invalid", readable: "Invalid date" };

  let day, month, year;

  // Detect format:
  // If first part has 4 digits → YYYY-MM-DD
  if (parts[0].length === 4) {
    [year, month, day] = parts;
  } else {
    [day, month, year] = parts;
  }

  // Pad for safety
  day = day.padStart(2, "0");
  month = month.padStart(2, "0");

  const isoDate = `${year}-${month}-${day}`;
  const date = new Date(isoDate);

  if (isNaN(date)) return { isoDate: "Invalid", readable: "Invalid date" };

  // Readable format — e.g. "27 June, 2025"
  const readable = date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  return { isoDate, readable };
}
       const [ reloadCalendar, setReloadCalendar] = useState(true);
            
     return(<div style={{margin:"5px",padding:"5px",background:`${dashboardCard1Object?.filterCardOuter?.bgColor?.color}`
           ,color:`${dashboardCard1Object?.filterCardOuter?.textColor?.color}`,
    border:` ${dashboardCard1Object?.filterCardOuter?.border?.borderWidth?.value+dashboardCard1Object?.filterCardOuter?.border?.borderWidth?.resolution} ${dashboardCard1Object?.filterCardOuter?.border?.borderType}  ${dashboardCard1Object?.filterCardOuter?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${dashboardCard1Object?.filterCardOuter?.borderRadius?.topLeft?.value}${dashboardCard1Object?.filterCardOuter?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${dashboardCard1Object?.filterCardOuter?.borderRadius?.topRight?.value}${dashboardCard1Object?.filterCardOuter?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${dashboardCard1Object?.filterCardOuter?.borderRadius?.bottomLeft?.value}${dashboardCard1Object?.filterCardOuter?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${dashboardCard1Object?.filterCardOuter?.borderRadius?.bottomRight?.value}${dashboardCard1Object?.filterCardOuter?.borderRadius?.bottomRight?.resolution}`}}>
  <div style={{display:"flex",justifyContent:"space-between",padding:"5px",position:"relative"}}>
    <h3 className="enrolledCoursesHeader" style={{marginTop:"8px",paddingBottom:"5px"}}>
            <span className="page-title hideXs dashboardPageTitleFont">{dropDownVal}  Courses</span> 
            <span className="page-title hideLg hideSm hideMd showXS dashboardPageTitleFont">{dropDownVal} </span>
           </h3> 
          <div style={{display:"flex",justifyContent:"space-between",paddingBo:"5px",gap:"9px"}}>
         <div style={{marginTop:"-11px",marginRight:"63px",transform:"scale(0.8)",position:"relative",zIndex:"99",width:"100px"}}>
                <DropDownButtonUIClient dashboardCard1Object={dashboardCard1Object} activeCard={""} icon={4} title={dropDownVal} 
                 onClickSendObject={(value)=>{  
                                    if(value){setDropDownVal(value);setPageNo(1) }}}
                  hasDropDown={true} dropDownObject={[{title:"Active",value:"Active"},
                    {title:"Expired",value:"Expired"},{title:"Cancelled",value:"Cancelled"}
                    ,{title:"Refunded",value:"Refunded"}]} />
                                                                                    
                                                                                    </div>  
 <div  className="calendarOuterDB" style={{position:"relative",cursor:"pointer",width:"30px",height:"30px",display:"flex",justifyContent:"center",alignItems:"center",background:`${dashboardCard1Object?.filterCalendarBtn?.bgColor?.color}`
           ,color:`${dashboardCard1Object?.filterCalendarBtn?.textColor?.color}`,
    border:` ${dashboardCard1Object?.filterCalendarBtn?.border?.borderWidth?.value+dashboardCard1Object?.filterCalendarBtn?.border?.borderWidth?.resolution} ${dashboardCard1Object?.filterCalendarBtn?.border?.borderType}  ${dashboardCard1Object?.filterCalendarBtn?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.topLeft?.value}${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.topRight?.value}${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.bottomLeft?.value}${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.bottomRight?.value}${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.bottomRight?.resolution}`}}>
<Calendar size={18} color={dashboardCard1Object?.filterCalendarBtn?.iconColor?.color} />
<div className="calendarInnerDB"> 
    <div style={{position:"absolute",}}><div style={{fontSize:"24px",padding:"5px 10px"}}>Enrollment Date Range</div>
 {reloadCalendar?<CalendarAll  dashboardCard1Object={dashboardCard1Object} returnSelectedRange={(v)=>{setEnrollStartDate(convertToYMD(v?.from));setEnrollEndDate(convertToYMD(v?.to));}} />:""}
     </div>
     </div>
</div>

             <div onClick={()=>{}} className="sortOuterDB" style={{cursor:"pointer",width:"30px",height:"30px",display:"flex",justifyContent:"center",alignItems:"center",background:`${dashboardCard1Object?.filterSortBtn?.bgColor?.color}`
           ,color:`${dashboardCard1Object?.filterSortBtn?.textColor?.color}`,
    border:` ${dashboardCard1Object?.filterSortBtn?.border?.borderWidth?.value+dashboardCard1Object?.filterSortBtn?.border?.borderWidth?.resolution} ${dashboardCard1Object?.filterSortBtn?.border?.borderType}  ${dashboardCard1Object?.filterSortBtn?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${dashboardCard1Object?.filterSortBtn?.borderRadius?.topLeft?.value}${dashboardCard1Object?.filterSortBtn?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${dashboardCard1Object?.filterSortBtn?.borderRadius?.topRight?.value}${dashboardCard1Object?.filterSortBtn?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${dashboardCard1Object?.filterSortBtn?.borderRadius?.bottomLeft?.value}${dashboardCard1Object?.filterSortBtn?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${dashboardCard1Object?.filterSortBtn?.borderRadius?.bottomRight?.value}${dashboardCard1Object?.filterSortBtn?.borderRadius?.bottomRight?.resolution}`}}>
<Filter size={18} color={dashboardCard1Object?.filterSortBtn?.iconColor?.color} />
<div className="sortInnerDB">
 
    <div onClick={()=>{setSort("ASC")}} className="sortInnerDBItemDB" style={sort=="ASC"?{background:`${dashboardCard1Object?.filterSortBtn?.bgColor?.color}`
           ,color:`${dashboardCard1Object?.filterSortBtn?.textColor?.color}`}:{background:`${dashboardCard1Object?.filterSortBtn?.textColor?.color}`
           ,color:`${dashboardCard1Object?.filterSortBtn?.bgColor?.color}`}}>Recent</div>
    <div onClick={()=>{setSort("DESC")}} className="sortInnerDBItemDB" style={sort=="DESC"?{background:`${dashboardCard1Object?.filterSortBtn?.bgColor?.color}`
           ,color:`${dashboardCard1Object?.filterSortBtn?.textColor?.color}`}:{background:`${dashboardCard1Object?.filterSortBtn?.textColor?.color}`
           ,color:`${dashboardCard1Object?.filterSortBtn?.bgColor?.color}`}}>Older</div>
    </div>
</div> </div> 

            </div> <div style={{display:"flex",justifyContent:"left",padding:"5px",gap:"5px",position:"relative",marginTop:"-30px"}}>
 {advancedFilters?<>
   <div style={{display:"flex",fontSize:"16px",justifyContent:"space-between",alignItems:"center",padding:"5px  10px",gap:"0px",width:"100px",background:`${dashboardCard1Object?.filterPaidTab?.bgColor?.color}`
           ,color:`${dashboardCard1Object?.filterPaidTab?.textColor?.color}`,
    border:` ${dashboardCard1Object?.filterPaidTab?.border?.borderWidth?.value+dashboardCard1Object?.filterPaidTab?.border?.borderWidth?.resolution} ${dashboardCard1Object?.filterPaidTab?.border?.borderType}  ${dashboardCard1Object?.filterPaidTab?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${dashboardCard1Object?.filterPaidTab?.borderRadius?.topLeft?.value}${dashboardCard1Object?.filterPaidTab?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${dashboardCard1Object?.filterPaidTab?.borderRadius?.topRight?.value}${dashboardCard1Object?.filterPaidTab?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${dashboardCard1Object?.filterPaidTab?.borderRadius?.bottomLeft?.value}${dashboardCard1Object?.filterPaidTab?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${dashboardCard1Object?.filterPaidTab?.borderRadius?.bottomRight?.value}${dashboardCard1Object?.filterPaidTab?.borderRadius?.bottomRight?.resolution}`}}>
         Paid    <label   class="player-switchmutesmall " style={{width:"80px"}}> 
 <input id="togglemute" checked={toggleStatePaid} onChange={e=>{if(e.target.checked){setToggleStatePaid(e.target.checked)}else{setToggleStatePaid(null)}}}   type="checkbox"  
    /> 
   
  <span class="player-cardlfmutesmall round" style={{background:`${dashboardCard1Object?.filterPaidTab?.iconColor?.color}`}}></span>
</label> 
</div> <div style={{display:"flex",fontSize:"16px",justifyContent:"space-between",alignItems:"center",padding:"5px  10px",gap:"0px",width:"120px",background:`${dashboardCard1Object?.filterLifetimeTab?.bgColor?.color}`
           ,color:`${dashboardCard1Object?.filterLifetimeTab?.textColor?.color}`,
    border:` ${dashboardCard1Object?.filterLifetimeTab?.border?.borderWidth?.value+dashboardCard1Object?.filterLifetimeTab?.border?.borderWidth?.resolution} ${dashboardCard1Object?.filterLifetimeTab?.border?.borderType}  ${dashboardCard1Object?.filterLifetimeTab?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${dashboardCard1Object?.filterLifetimeTab?.borderRadius?.topLeft?.value}${dashboardCard1Object?.filterLifetimeTab?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${dashboardCard1Object?.filterLifetimeTab?.borderRadius?.topRight?.value}${dashboardCard1Object?.filterLifetimeTab?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${dashboardCard1Object?.filterLifetimeTab?.borderRadius?.bottomLeft?.value}${dashboardCard1Object?.filterLifetimeTab?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${dashboardCard1Object?.filterLifetimeTab?.borderRadius?.bottomRight?.value}${dashboardCard1Object?.filterLifetimeTab?.borderRadius?.bottomRight?.resolution}`}}>
         Lifetime   <label   class="player-switchmutesmall " style={{width:"80px"}}> 
 <input id="togglemute" checked={toggleStateLifetime} onChange={e=>{if(e.target.checked){setToggleStateLifetime(e.target.checked)}else{setToggleStateLifetime(null)}}}   type="checkbox"  
    /> 
   
  <span class="player-cardlfmutesmall round"  style={{background:`${dashboardCard1Object?.filterLifetimeTab?.iconColor?.color}`}}></span>
</label> 

</div> <div  className="calendarOuterDB" style={{cursor:"pointer",width:"30px",height:"30px",display:"flex",justifyContent:"center",alignItems:"center",position:"relative",background:`${dashboardCard1Object?.filterCalendarBtn?.bgColor?.color}`
           ,color:`${dashboardCard1Object?.filterCalendarBtn?.textColor?.color}`,
    border:` ${dashboardCard1Object?.filterCalendarBtn?.border?.borderWidth?.value+dashboardCard1Object?.filterCalendarBtn?.border?.borderWidth?.resolution} ${dashboardCard1Object?.filterCalendarBtn?.border?.borderType}  ${dashboardCard1Object?.filterCalendarBtn?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.topLeft?.value}${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.topRight?.value}${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.bottomLeft?.value}${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.bottomRight?.value}${dashboardCard1Object?.filterCalendarBtn?.borderRadius?.bottomRight?.resolution}`}}>
<Calendar size={18} color={dashboardCard1Object?.filterCalendarBtn?.iconColor?.color} />
<div className="calendarInnerDB">
    <div style={{position:"absolute",}}><div style={{fontSize:"24px",padding:"5px 10px"}}>Expiry Date Range</div>
 {reloadCalendar?<CalendarAll  dashboardCard1Object={dashboardCard1Object}  returnSelectedRange={(v)=>{setExpStartDate(convertToYMD(v?.from));setExpEndDate(convertToYMD(v?.to));}} />:""}
     </div>
     </div>
</div><div onClick={()=>{setAdvancedFilters(false);setToggleStatePaid(null);setToggleStateLifetime(null);setExpStartDate(null);setExpEndDate(null)}} style={{cursor:"pointer",display:"flex",fontSize:"12px",justifyContent:"space-between",alignItems:"center",padding:"5px 10px",gap:"3px",width:"20px",background:`${dashboardCard1Object?.filterAdvancedTab?.bgColor?.color}`
           ,color:`${dashboardCard1Object?.filterAdvancedTab?.textColor?.color}`,
    border:` ${dashboardCard1Object?.filterAdvancedTab?.border?.borderWidth?.value+dashboardCard1Object?.filterAdvancedTab?.border?.borderWidth?.resolution} ${dashboardCard1Object?.filterAdvancedTab?.border?.borderType}  ${dashboardCard1Object?.filterAdvancedTab?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.topLeft?.value}${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.topRight?.value}${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.bottomLeft?.value}${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.bottomRight?.value}${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.bottomRight?.resolution}`}} >
<X size={18} color={dashboardCard1Object?.filterAdvancedTab?.iconColor?.color} />  </div> </>:<div onClick={()=>{setAdvancedFilters(true)}} style={{cursor:"pointer",display:"flex",fontSize:"16px",justifyContent:"space-between",alignItems:"center",padding:"10px",gap:"0px",width:"150px",background:`${dashboardCard1Object?.filterAdvancedTab?.bgColor?.color}`
           ,color:`${dashboardCard1Object?.filterAdvancedTab?.textColor?.color}`,
    border:` ${dashboardCard1Object?.filterAdvancedTab?.border?.borderWidth?.value+dashboardCard1Object?.filterAdvancedTab?.border?.borderWidth?.resolution} ${dashboardCard1Object?.filterAdvancedTab?.border?.borderType}  ${dashboardCard1Object?.filterAdvancedTab?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.topLeft?.value}${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.topRight?.value}${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.bottomLeft?.value}${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.bottomRight?.value}${dashboardCard1Object?.filterAdvancedTab?.borderRadius?.bottomRight?.resolution}`}} >
<Filter size={18} color={dashboardCard1Object?.filterAdvancedTab?.iconColor?.color} />  Advanced Filters </div>}
      
</div> 
<style>{`
.enrolledCoursesHeader{width:100%}
 .sortInnerDBItemDB{height:20px;cursor:pointer;display:flex;justify-content:left;gap:8px;background:#fff;padding:3px 5px;border-radius:5px;margin-bottom:5px;font-size:14px;}
    .sortOuterDB .sortInnerDB{z-index:999999;border:2px solid ${dashboardCard1Object?.filterSortBtn?.bgColor?.color};width:125px;transition: 0.4s ease;height:60px;background:rgba(228, 237, 244, 1);;border-radius:5px;position:absolute;top:50px;right:15px;visibility:hidden;opacity:0;transition: 0.1s ease;}
     .sortOuterDB:hover .sortInnerDB{display:block;visibility:visible;opacity:1;transition: 0.4s ease;padding:5px}

 .sortInnerDB::after {
    content: "";
    position: absolute;
   top: -16px;
    right: 0px;
    margin-left: 2px;
    border-width: 8px;
    border-style: solid;
    border-color:  transparent  transparent ${dashboardCard1Object?.filterSortBtn?.bgColor?.color}   transparent ;
  }
   .sortInnerDBItemDB:hover{transform:scale(0.9);transition: 0.1s ease;}
   
     .calendarOuterDB .calendarInnerDB{transform:scale(0.6);
     z-index:999999;border:2px solid ${dashboardCard1Object?.filterCalendarBtn?.bgColor?.color};width:340px;height:430px;background:#ffffff;border-radius:15px;position:absolute;visibility:hidden;top:-25px;right:-75px;opacity:0;transition: 0.1s ease;}
     .calendarOuterDB:hover .calendarInnerDB{transform:scale(0.7);display:block;opacity:1;visibility:visible;top:-15px;;transition: 0.4s ease;padding:5px}

 .calendarInnerDB::after {
    content: "";
    position: absolute;
   top: -16px;
    right: 45px;
    margin-left: 2px;
    border-width: 8px;
    border-style: solid;
    border-color:  transparent  transparent ${dashboardCard1Object?.filterCalendarBtn?.bgColor?.color}   transparent ;
  }
 
.player-switchmutesmall {
    position: relative;
    display: inline-block;
    width: 77px;
    transform: scale(0.4);
    height: 25px;
    
  }
  
  .player-switchmutesmall input {display:none;}
  
  .player-cardlfmutesmall {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    box-shadow:0 7px 20px 0 rgba(144, 202, 249,0.3);
    -webkit-transition: .4s;
    transition: .4s;
  }
  .player-cardlfmutesmall:before {
    position: absolute;
    content: "";
    height: 30px;
    width: 30px;
    left: 0px;
    bottom: -6px;
    background:rgba(5, 5, 5, 1);box-shadow:0 7px 20px 0 rgba(144, 202, 249,0.03);;border:7px solid #f9f9f9;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  input:checked + .player-cardlfmutesmall {
     background: #222222 !important;box-shadow:0 7px 20px 0 rgba(144, 202, 249,0.3);
  }
  
  input:focus + .player-cardlfmutesmall {
    box-shadow: 0 0 1px #2196F3;
  }
  
  input:checked + .player-cardlfmutesmall:before {
    -webkit-transform: translateX(40px);
    -ms-transform: translateX(40px);
    transform: translateX(40px);
  }
  
  /* Rounded player-cardlfmutesmalls */
  .player-cardlfmutesmall.round {
    border-radius: 34px;
  }
  
  .player-cardlfmutesmall.round:before {
    border-radius: 50%;
  }
  
  .mutetitle{ position:relative; padding:5px;font-size:18px;top:-7px; font-weight:bold; }
  
  

.hideLg{display:none;}
/* md */
@media (min-width: 992px) and (max-width: 1199px) {

.hideMd{display:none;}
}

      /* sm */
@media (min-width: 768px) and (max-width: 991px) {

.hideSm{display:none;}.storageInfoData{position:relative;width:100%;}
} 

/* xs */
@media (max-width: 767px) {
.enrolledCoursesHeader{width:100px}
.hideXs{display:none;}
.showXS{display:block !important;}

        }
        `}</style>

    </div>)
}
export default FilterTopDash;